import { Person, LocalMallOutlined, StoreOutlined, CardGiftcardOutlined } from '@material-ui/icons';
import { capitalize } from 'lodash-es';

import { formatGiftCardNumber } from 'components/utils';
import { routes } from 'utils/routing';

import { SearchResult } from './types';

export const searchResultDisplayMap = {
  CustomerDetails: {
    icon: (_result: SearchResult) => <Person />,
    tooltip: (_result: SearchResult) => 'Customer',
    route: (result: SearchResult) => `${routes.customer}/${result.id}`,
    display: (result: SearchResult) => 'email' in result && result.email,
  },
  UserSearchResult: {
    icon: (_result: SearchResult) => <Person />,
    tooltip: (_result: SearchResult) => 'Customer',
    route: (result: SearchResult) => `${routes.customer}/${result.id}`,
    display: (result: SearchResult) => 'userEmail' in result && result.userEmail,
  },
  Order: {
    icon: (_result: SearchResult) => <LocalMallOutlined />,
    tooltip: (_result: SearchResult) => 'Order',
    route: (result: SearchResult) =>
      'customer' in result &&
      'id' in result.customer! &&
      `${routes.customer}/${result.customer.id}${routes.orders}/${result.id}`,
    display: (result: SearchResult) => result.id,
  },
  PrepaidCard: {
    icon: (_result: SearchResult) => <CardGiftcardOutlined />,
    tooltip: (_result: SearchResult) => 'Gift Card',
    route: (_result: SearchResult) => routes.giftCard,
    display: (result: SearchResult) => {
      if ('alias' in result && result.alias) {
        return result.alias;
      }
      if ('cardNumber' in result && result.cardNumber) {
        return formatGiftCardNumber(result.cardNumber);
      }
      return result.id;
    },
  },
  Store: {
    icon: (_result: SearchResult) => <StoreOutlined />,
    tooltip: (result: SearchResult) => `Store ${'storeNumber' in result && result.storeNumber}`,
    route: (result: SearchResult) => `${routes.store}/${result.id}`,
    display: (result: SearchResult) =>
      'storeAddress' in result &&
      'storeNumber' in result &&
      [result.storeAddress?.address1, result.storeAddress?.city]
        .filter(Boolean)
        .join(', ')
        .toLowerCase()
        .split(' ')
        .map((word) => capitalize(word))
        .join(' '),
  },
};
